// removed by extract-text-webpack-plugin
module.exports = {"sortRow":"company_sortRow_3C6xT","sortList":"company_sortList_2eNYI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/regulatoryStatistical/index/financialOverview/company.scss
// module id = 1562
// module chunks = 0